import React from 'react';
import { useThemeContext } from '../../contexts';

type IconProps = {
  iconWidth?: number;
  iconHeight?: number;
};

/**
 * CardsIcon is a component that displays a cards icon.
 *
 * @param {IconProps} props
 * @return {React.FC}
 */
const CardsIcon: React.FC<IconProps> = (props) => {
  const { theme } = useThemeContext();
  return (
    <svg
      width={props.iconWidth}
      height={props.iconHeight}
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.5597 38.6667H101.467C111.496 38.6667 119.758 39.7918 125.129 45.091C130.522 50.413 131.667 58.6203 131.667 68.5333V110.598C135.527 109.861 137.485 108.627 138.673 107.128C140.534 104.78 141.667 100.432 141.667 91.4667V44.8667C141.667 34.9131 140.278 30.687 138.105 28.5423C135.908 26.3748 131.571 25 121.467 25H58.5333C48.6001 25 44.2391 26.319 42.0094 28.4167C40.3086 30.0168 39.0546 32.8406 38.5597 38.6667ZM35.1573 21.1333C40.5275 16.081 48.6665 15 58.5333 15H121.467C131.496 15 139.758 16.1252 145.129 21.4244C150.522 26.7464 151.667 34.9536 151.667 44.8667V91.4667C151.667 100.502 150.699 108.053 146.51 113.339C142.1 118.903 135.207 120.704 126.962 121.191C125.587 121.273 124.239 120.783 123.237 119.838C122.235 118.894 121.667 117.577 121.667 116.2V68.5333C121.667 58.5797 120.278 54.3536 118.105 52.209C115.908 50.0415 111.571 48.6667 101.467 48.6667H38.5333C36.7792 48.6667 35.1358 48.7292 33.5415 48.7957C32.1713 48.8528 30.8379 48.3446 29.8532 47.3901C28.8686 46.4356 28.3192 45.1186 28.3336 43.7474C28.434 34.2078 29.7004 26.267 35.1573 21.1333Z"
        fill={theme.secondary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33333 84.0669C8.33333 81.3055 10.5719 79.0669 13.3333 79.0669H126.667C129.428 79.0669 131.667 81.3055 131.667 84.0669C131.667 86.8283 129.428 89.0669 126.667 89.0669H13.3333C10.5719 89.0669 8.33333 86.8283 8.33333 84.0669Z"
        fill={theme.primary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.5856 48.7937C26.0616 49.2433 22.964 50.8065 21.3268 52.8722C19.4661 55.2199 18.3333 59.5683 18.3333 68.5332V115.133C18.3333 125.087 19.7219 129.313 21.8953 131.458C24.0918 133.625 28.4293 135 38.5333 135H101.467C111.4 135 115.761 133.681 117.991 131.583C120.132 129.569 121.565 125.615 121.667 116.173V68.5332C121.667 58.5796 120.278 54.3535 118.105 52.2088C115.908 50.0413 111.571 48.6665 101.467 48.6665H38.5333C36.7954 48.6665 35.1661 48.7279 33.5856 48.7937ZM33.1252 38.8042C34.7308 38.7373 36.5541 38.6665 38.5333 38.6665H101.467C111.496 38.6665 119.758 39.7917 125.129 45.0909C130.522 50.4129 131.667 58.6201 131.667 68.5332V116.2L131.666 116.252C131.566 125.792 130.3 133.733 124.843 138.867C119.472 143.919 111.333 145 101.467 145H38.5333C28.504 145 20.2416 143.875 14.8714 138.575C9.4781 133.253 8.33333 125.046 8.33333 115.133V68.5332C8.33333 59.498 9.30053 51.9465 13.4898 46.6608C17.8995 41.0971 24.7934 39.2956 33.0385 38.8085L33.1252 38.8042Z"
        fill={theme.primary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 118.727C30 115.965 32.2386 113.727 35 113.727H46.4667C49.2281 113.727 51.4667 115.965 51.4667 118.727C51.4667 121.488 49.2281 123.727 46.4667 123.727H35C32.2386 123.727 30 121.488 30 118.727ZM55.7333 118.727C55.7333 115.965 57.9719 113.727 60.7333 113.727H83.6667C86.4281 113.727 88.6667 115.965 88.6667 118.727C88.6667 121.488 86.4281 123.727 83.6667 123.727H60.7333C57.9719 123.727 55.7333 121.488 55.7333 118.727Z"
        fill={theme.secondary}
      />
    </svg>
  );
};

export default CardsIcon;
